import { FC } from 'react'

// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import { postSelectPostDeleteModalOpen, postClosePostDeleteModal } from '@/features'
// components
import { ModalLayout } from '@/components'

// components
import { PostDeleteCard } from './components'
// styles
import { styles } from './styles'

type PostDeleteModalProps = {}

export const PostDeleteModal: FC<PostDeleteModalProps> = () => {
  const dispatch = useAppDispatch()
  const deletePostModalOpen = useAppSelector(postSelectPostDeleteModalOpen)

  return (
    <div css={styles().modal.main}>
      {deletePostModalOpen && (
        <ModalLayout
          background="opaque"
          onOutsideClick={() => dispatch(postClosePostDeleteModal())}
        >
          <div css={styles().modal.content}>
            <PostDeleteCard />
          </div>
        </ModalLayout>
      )}
    </div>
  )
}

PostDeleteModal.propTypes = {}
